import { useState } from "react";
import { ChatImageViewer } from "features/shared";

export const ChatMessageImage = ({ url }: { url: string }) => {
  const [preview, setPreview] = useState(false);

  return (
    <>
      <div
        className="cursor-pointer hover:opacity-90 active:opacity-70 transition-all"
        onClick={() => setPreview(true)}
      >
        <img src={url} alt="" className="max-w-[200px] h-auto" />
      </div>
      {preview && <ChatImageViewer url={url} onClose={() => setPreview(false)} />}
    </>
  );
};
